const Form064EN = {
    stepName: {
        Statement: "Important Notes",
        schoolInfo: "Basic Information",
        actingAppointment: "Acting Appointment Details",
        Certification: "Certification",
        NoteInformation: "Note Information",
        confirmation: "Confirmation",
    },
    header: {
        // labelOne:
        //     "The School Management Committee/Incorporated Management Committee has approved the following acting appointment (Ref. No. and Date:____).",
        // labelTwo: "The Consequential Change in Salary Particulars",
        labelThree:
            "For acting appointment to the post of school head, please provide details of prior approval sought from Education Bureau.",
        labelFour: "The above acting appointment arises from",
        labelFive: "The Acting Staff's Functional Responsibilities",
        labelCertification: "Certification",
    },
    label: {
        // programOption: {
        //     am: "AM",
        //     Pm: "PM",
        //     WholeDay: "Whole Day",
        // },
        committeeOption: {
            SMC: "School Management Committee",
            IMC: "Incorporated Management Committee",
        },
        actingOption: {
            actingUp:
                "Acting-up: ____% of difference between his/her substantive pay & MPS Pt. _____",
            doublingUp:
                "Doubling-up:23% of the minimum salary of the higher rank or 100% of the difference in pay between the teacher’s substantive salary and the minimum salary of the higher rank in which he/she is acting",
        },
        appointmentOption: {
            a: "(a) the sick/maternity/study/no-pay leave of Mr/Ms _________, _____(Rank of the teacher), for the period from ____/____/____ to ____/____/____ inclusive [Approval from EDB – File Ref. No. and Date: _____________________].",
            b: "(b) unfilled promotion post / promotion post left vacant due to wastage",
            c: "(c) other reasons (please specify) ____________Approval from EDB–File Ref. No. and Date: _________].",
        },
        leaveTypeOption: {
            sick: "sick leave",
            maternity: "maternity leave",
            study: "study leave",
            noPay: "no-pay leave",
        },
        promotionTypeOption: {
            unfilledPost: "Unfilled promotion post",
            wastagePost: "Promotion post left vacant due to wastage",
        },
        salaryPointOption: {
            0: "0",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13",
            14: "14",
            15: "15",
            16: "16",
            17: "17",
            18: "18",
            19: "19",
            20: "20",
            21: "21",
            22: "22",
            23: "23",
            24: "24",
            25: "25",
            26: "26",
            27: "27",
            28: "28",
            29: "29",
            30: "30",
            31: "31",
            32: "32",
            33: "33",
            34: "34(33A)",
            35: "35(33B)",
            36: "36(33C)",
            37: "37",
            38: "38",
            39: "39",
            40: "40",
            41: "41",
            42: "42",
            43: "43",
            44: "44",
            45: "45(44A)",
            46: "46(44B)",
            47: "47",
            48: "48",
            49: "49",
        },
        titleOption: {
            Mr: "Mr",
            Ms: "Ms",
        },
        note: "Note",
        statement: "Personal Information Collection Statement",
        termsConditions:
            'I have read the "Personal Information Collection Statement" and fully understand its content.',
        approverOnly:
            'I understand that an "iAM Smart+" account is required for processing the application.',

        schoolName: "School Name",
        schoolCode: "School Code",
        schoolProgram: "School Session",
        contactPerson: "Contact person",
        telNum: "Telephone number",

        head1: "<b><i>Original</i></b>",
        head2: "- Funds Section, Education Bureau",
        head3: "<b><i>Duplicate</i></b>",

        contactAndTelText1: "School's contact person",
        contactAndTelText2: "and tel. no.",
        contactAndTelText3: "(for enquiry by EDB in processing this form)",
        ssdo: "- Respective Regional Education Office [Attn : ",
        ssdo2: "] Education Bureau",
        SSDO: "SSDO",
        head4: "<b><i>Triplicate</i></b>",
        head5: "- School’s Record",

        committee: "Committee",

        committeeText1: "The *",
        committeeText2:
            "has approved the following acting appointment (Ref. No.",
        committeeText3: "and Date:",
        committeeText4: ")",
        committeeText5: "and the consequential change in salary particulars:",

        referenceNum: "Reference number",
        approvalDate: "Date",
        englishName: "Name of Teacher in English",
        chineseName: "Name of Teacher in Chinese",
        HKICNo: "HKIC No.",
        SRN: "SRN",
        rank: "Substantive Rank",
        appointRank: "Rank of Acting Appointment",
        rankschoolHead: "School Head",
        schoolHeadTrue: "Yes",
        schoolHeadFalse: "No",
        actingPeriod: "Acting Period",
        actingFrom: "From",
        actingTo: "To",
        actingType: "Acting Allowance:",
        MPSDiff: "Difference between substantive pay and MPS point",
        MPSPoint: "MPS point:",

        fileRefNo: "File Ref. No.",
        fileDate: "File Date:",
        approvalFile: "Approval Letter:",

        leaveType: "Leave Type:",
        teacherTitle: "Title:",
        teacherName: "Name",
        teacherRank: "Rank of the teacher",
        dateFrom: "Period From",
        dateTo: "Period To",

        aLabel1: "(a) the",
        aLabel9: "of",
        aLabel2: "(Rank of the",
        aLabel3: "teacher) , for the period from",
        aLabel4: "to",
        aLabel5: "inclusive [Approval from",
        aLabel6: "EDB – File Ref. No.",
        aLabel7: ",",
        aLabel8: "].",

        promotionPost: "(b) Promotion post",
        otherReason: "(c) Other reasons (please specify)",
        refNo: "[Approval from EDB – File Ref. No.",
        refDate: "and Date:",
        errorReason: "reasons",

        tooltip1: "Doubling-up",
        tooltip2:
            ":23% of the minimum salary of the higher rank or 100% of the difference in pay between the teacher’s substantive salary and the minimum salary of the higher rank in which he/she is acting",

        tooltip3: "Acting-up:",
        tooltip4: "% of difference between his/her substantive pay & MPS Pt.",
        confirm: "Confirm",
    },

    schoolInfoNote: [
        { text: "Basic Information" },
        {
            text: "Please complete one form for each acting appointment.",
        },
        {
            text: "Please read the Personal Information Collection Statement carefully before completing this form.",
        },
        {
            text: "Please ensure the content of this form is made known to the teacher and he/she has read the Personal Information Collection Statement. ",
        },
    ],
    salaryInfo: {
        detailSix1:
            "I undertake that if the above teacher's acting period cannot meet the requirements of qualifying period for granting acting allowance",
        detailSix2:
            "as specified in paragraph 2 of EDB Circular No. 8/2004, I shall advise the Funds Section of your Bureau promptly with a copy to the respective school development officer.",
        detailSeven:
            "I confirm that the particulars in Basic information and Acting Appointment Details of this form are correct. I undertake that the acting appointment will not result in having the number of staff holding the posts at the promotion ranks in excess of our approved entitlement. I also undertake my School shall refund any over-payment of salaries grant to the Education Bureau.",
    },
    noteList: [
        {
            text: "All the necessary procedures for making acting appointment should be completed before the effective date, including the approval by the SMC/IMC. Under  normal circumstances, there should be no retrospective effect for the date of acting appointment.",
        },
        {
            text: "For secondary schools, secondary special schools or the secondary section of combined level special schools, a full-time regular PGM/SGM/GM or SAM who  has been recommended and approved to take up the functional duties of a higher office in the rank of PI/PII/PGM/SGM or PAM as appropriate on an acting basis for a qualifying period of not less than 30 calendar days will be entitled to draw an acting allowance.",
        },
        {
            text: "If leave exceeding 3 consecutive working days affects the calculation of the qualifying period and/or involves the forfeiture of acting allowance for the whole  period of leave of the teacher on the acting appointment to eligible ranks (including leave and intervening public holidays and Sundays), please inform this  Bureau for adjustment of acting allowance by completing the Acting Appointment Form (Notification for Adjustment of Acting Allowance of Teacher on Acting  Appointment Taking Leave/Absence for More than 3 Consecutive Days).",
        },
        {
            text: "Starting from the 2019/20 school year, if schools arrange a graduate teacher at basic rank to take up an acting-up appointment to a promotion post in the non-graduate grade for administrative convenience when the post is left vacant due to temporary absence of the substantive holder for a qualifying period of not less  than 30 calendar days, the graduate teacher will be eligible for an acting-up rate at 90% of the difference in pay between the minimum pay of the acting post (i.e. corresponding promotional post in the graduate grade) and the substantive pay of the teacher concerned.",
        },
        {
            text: "For details, please refer to EDB Circular No. 8/2004 and the relevant Code of Aid.",
        },
        {
            text: "Starting from the 2019/20 school year, under the all-graduate teaching force policy, all teaching posts on the approved establishment of aided schools are  graduate teacher posts, in other words, there should not be acting appointment in the non-graduate grade due to unfilled/ vacant promotion posts.",
        },
        {
            text: "EDB will perform pre-processing entitlement checking on each acting appointment. If the acting appointment of staff would exceed the approved entitlement of teaching staff of the school on the relevant acting appointment date, no Salaries Grant with respect to that acting appointment will be paid to the school until the acting appointment is confirmed in order.",
        },
    ],

    errorMsg: {
        numLimit: "Please enter {{limit}}",
        tel: {
            max: "Telephone number must be at most {{max}} digits",
        },
        actingPeriod: "The periods should not be the same",
        actLaterApproval:
            "All the necessary procedures for making acting appointment should be completed before the effective date, including the approval by the SMC/IMC. Under normal circumstances, there should be no retrospective effect for the date of acting appointment.",
        codeDigit: "This field must be exactly {{digit}} digits",
        comparePeriod:
            "The acting period should be bounded within the leave period (the sick/maternity/study/no-pay leave).",
        schHeadApproval:
            "Prior approval should be sought from Education Bureau. For enquiries, please contact the respective School Development Officers.",
    },
};

export default Form064EN;
